import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _readOnlyError from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getActivityProduct, addActivity } from '@/services/marketing/activity';
import Cookie from 'js-cookie';
import { Tree } from 'ant-design-vue';
import { TreeSelect } from 'ant-design-vue';
import FooterToolBar from '@/components/tool/FooterToolBar';
import importfailed from '@/components/importfailed/index';
import selectProduct from '@/components/commonAdd/selectGroupGoods.vue';
export default {
  name: 'ActivityProduct',
  i18n: require('../i18n-activity'),
  components: {
    TreeSelect: TreeSelect,
    Tree: Tree,
    FooterToolBar: FooterToolBar,
    importfailed: importfailed,
    selectProduct: selectProduct
  },
  props: {
    basicInformation: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var buyLimitNumValidatePass = function buyLimitNumValidatePass(rule, value, callback) {
      if (_this.chooseproductparam.buyLimit === 1 && (_this.chooseproductparam.buyLimitNum === '' || _this.chooseproductparam.buyLimitNum === null)) {
        //请输入
        callback(new Error(_this.$t('activity.limitprop')));
      } else {
        callback();
      }
    };
    var propnumberValidatePass = function propnumberValidatePass(rule, value, callback) {
      if (_this.modalValue.productNum === '' || _this.modalValue.productNum === null || _this.modalValue.productNum === 0) {
        //请输入参与件数
        callback(new Error(_this.$t('activity.propnumber')));
      } else {
        callback();
      }
    };
    var activityContentValidatePass = function activityContentValidatePass(rule, value, callback) {
      if (_this.chooseproductparam.activityContent === '' || _this.chooseproductparam.activityContent === null || _this.chooseproductparam.activityContent === 0) {
        //请输入参与件数
        callback(new Error(_this.$t('activity.discountprop')));
      } else {
        callback();
      }
    };
    return {
      selectedRowKeys: [],
      activityinfoparam: {},
      limitdis: true,
      productList: [],
      isTableLoading: false,
      listTotal: 0,
      crrentPageProductList: [],
      chooseproductparam: {
        //商品类型
        productType: 1,
        //折扣
        activityContent: '',
        checkedKeys: [],
        //限购设置类型
        buyLimit: 0,
        //限购设置的数量
        buyLimitNum: ''
      },
      defaultLangObj: JSON.parse(localStorage.defaultLangObj),
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      rangeRules: {
        activityContent: [{
          required: true,
          validator: activityContentValidatePass,
          // message: this.$t('activity.discountprop'),
          trigger: 'blur'
        }]
      },
      importObj: {},
      importVisible: false,
      files: '',
      newheaders: {
        headers: ''
      },
      action: process.env.VUE_APP_API_BASE_URL + "/activity/importGoods/",
      buttonType: 2,
      dialogStatus: '',
      textMap: {
        batchoff: this.$t('activity.batchoff'),
        batchnumber: this.$t('public.batchnumber'),
        batchinvalid: this.$t('batchDelete')
      },
      /* 弹框验证 */
      modalRules: {
        productNum: [{
          required: true,
          validator: propnumberValidatePass,
          // message: this.$t('activity.propnumber'),
          trigger: 'blur'
        }],
        discount: [{
          required: true,
          // validator: propnumberValidatePass,
          message: this.$t('activity.discountprop'),
          trigger: 'blur'
        }]
      },
      rules: {
        buyLimitNum: [{
          validator: buyLimitNumValidatePass,
          trigger: 'blur'
        }]
      },
      //如果有新增的商品存入的值
      addProductIds: [],
      //选中的商品list
      selectProductList: [],
      //失效的商品ids
      deleteProductIds: [],
      //新增的商品ids
      productIds: [],
      removeTypeVisible: false,
      modalValue: {
        removeType: 0,
        productNum: '',
        discount: ''
      },
      selectNumber: 0,
      queryParam: {
        page: 1,
        size: 5
      },
      updateLoading: false,
      datavalue: {
        name: '',
        total: ''
      },
      AllStatus: [],
      // 高级搜索 展开/关闭
      advanced: false,
      visible: false,
      addproductList: [],
      expandedKeys: ["0-1"],
      autoExpandParent: true,
      selectedKeys: [],
      commodityClassificationList: [],
      sortedInfo: {
        columnKey: 'productStatus',
        order: "ascend"
      },
      total: 0,
      addList: [],
      alreadySelect: [],
      saveList: []
    };
  },
  watch: {
    'selectProductList': function selectProductList() {
      // console.log(this.selectProductList)
      this.selectNumber = this.selectProductList.length;
    },
    'chooseproductparam.buyLimitNum': function chooseproductparamBuyLimitNum() {
      if (this.chooseproductparam.buyLimit == 1) {
        this.$refs.ruleForm.validateField(["buyLimitNum"]);
      } else {
        this.$refs.ruleForm.clearValidate(["buyLimitNum"]);
      }
    },
    'chooseproductparam.activityContent': function chooseproductparamActivityContent() {
      if (this.chooseproductparam.activityContent == '' || this.chooseproductparam.activityContent == 0) {
        this.$refs.rangeRuleForm.validateField(["activityContent"]);
      }
    }
  },
  activated: function activated() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
    this.$route.query.id && this.getData();
  },
  created: function created() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
    this.$route.query.id && this.getData();
  },
  computed: {
    columns: function columns() {
      var sortedInfo = this.sortedInfo;
      sortedInfo = sortedInfo || {};
      var columns = [{
        title: this.$t('publicuse.goodsno'),
        dataIndex: 'productNo',
        key: 'productNo',
        width: '20%',
        align: 'left'
      }, {
        dataIndex: 'goodsName',
        title: this.$t('publicuse.goodsname'),
        key: 'goodsName',
        width: '40%',
        scopedSlots: {
          customRender: 'goodsName' //自定义表格里面的内容
        },
        ellipsis: true,
        align: 'left'
      },
      // {
      // 	title: this.$t('publicuse.status'),
      // 	dataIndex: 'productStatus',
      // 	key: 'productStatus',
      // 	width: '100px',
      // 	className: 'status-class',
      // 	scopedSlots: {
      // 		customRender: 'product-status', //自定义表格里面的内容
      // 	},
      // 	defaultSortOrder: 'ascend',
      // 	sorter: (a, b) => a.productStatus - b.productStatus,
      // 	sortOrder: sortedInfo.columnKey === 'productStatus' && sortedInfo.order
      // }, 
      {
        title: this.$t('publicuse.status'),
        dataIndex: 'status',
        key: 'status',
        width: '20%',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: this.$t('activity.inventoryquantity'),
        dataIndex: 'productStocknum',
        key: 'productStocknum',
        width: '10%',
        align: 'right'
      }, {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        width: '20%',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center'
      }];
      return columns;
    }
  },
  methods: {
    /* 上一步 */prevStep: function prevStep() {
      this.$emit('prevStep');
    },
    /* 子组件关闭的方法 */getVisible: function getVisible(visible) {
      this.importVisible = visible;
    },
    handleChange: function handleChange(info) {
      var _this2 = this;
      var fileList = _toConsumableArray(info.fileList);
      var activityId = null;
      var productStatus = 0;
      if (this.chooseproductparam.productType == 2) {
        productStatus = 1;
      }
      fileList = fileList.slice(-1);
      if (fileList[0].response != undefined) {
        var newRes = fileList[0].response;
        if (newRes.code == 200) {
          //如果有导入失败的话，需要展示出导入失败的list
          if (newRes.failList.length > 0) {
            this.importVisible = true;
            this.importObj = {
              failList: newRes.failList,
              failNum: newRes.failNum,
              successList: newRes.successList,
              successNum: newRes.successNum
            };
          }
          //如果有导入成功的话，需要吧导入成功的list，添加到列表中
          //如果原来商品list中已经存在的，以商品list中为主
          var oldProductList = _.cloneDeep(this.productList);
          _.remove(newRes.successList, function (o) {
            return oldProductList.findIndex(function (item) {
              return item.productOptionId === o.productSpecId;
            }) !== -1; //o.productSpecId != oldItem.productOptionId;
          });
          console.log(newRes.successList);
          // oldProductList.forEach(oldItem => {
          // 	newRes.successList = _.remove(newRes.successList, function(o) {
          // 		return o.productSpecId != oldItem.productOptionId;
          // 	});
          // })
          if (newRes.successList.length > 0) {
            newRes.successList.forEach(function (item) {
              var newObj = {
                activityContent: '',
                activityId: activityId,
                id: null,
                lastUpdateTime: null,
                productName: item.goodsName,
                productNo: item.goodsNo,
                productNum: '',
                productOptionId: item.productSpecId,
                productOptionName: item.specName,
                productPrice: item.price,
                productStatus: productStatus,
                productStockNum: item.productStockNum,
                productId: item.productId
              };
              _this2.productList.push(newObj);
            });
            var newproductList = _.cloneDeep(this.productList);
            this.crrentPageProductList = newproductList.slice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
            this.listTotal = this.productList.length;
            this.$message.success(this.$t("public.importsucceeded"));
          }
        } else {
          this.$message.error(this.$t("public.importfail"));
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      this.files = file;
      var extension = file.name.split('.')[1] === 'xls';
      var extension2 = file.name.split('.')[1] === 'xlsx';
      var isLt5M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message.error(this.$t("public.exportpromptone"));
        return false;
      }
      if (!isLt5M) {
        this.$message.error(this.$t("public.exportprompytwo"));
        return false;
      }
    },
    changelimit: function changelimit(type) {
      if (type == 0) {
        this.limitdis = true;
        this.chooseproductparam.buyLimitNum = '';
      } else {
        this.limitdis = false;
      }
    },
    onChange: function onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onSelect: function onSelect(record, selected, selectedRows) {
      //如果选中，添加进去
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, record);
        console.log(this.selectProductList, '选中了');
      } else {
        console.log(record, '取消选中');
        //取消选中，失效
        this.selectProductList = _.remove(this.selectProductList, function (o) {
          return o.optionId != record.optionId;
        });
        console.log(this.selectProductList);
      }
    },
    onSelectAll: function onSelectAll(selected, selectedRows, changeRows) {
      var _this3 = this;
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, changeRows);
      } else {
        changeRows.forEach(function (item) {
          //取消选中，失效
          _this3.selectProductList = _.remove(_this3.selectProductList, function (o) {
            return o.optionId != item.optionId;
          });
        });
      }
    },
    /* 切换批量失效类型 */removeTypeChange: function removeTypeChange() {},
    removeModal: function removeModal() {
      var _this4 = this;
      //判断是 选择的值，还是 当前页，还是全部页
      var lodingData = [];
      console.log(this.modalValue.removeType);
      if (this.modalValue.removeType == 0) {
        lodingData = _.cloneDeep(this.selectProductList);
      } else if (this.modalValue.removeType == 1) {
        lodingData = _.cloneDeep(this.crrentPageProductList);
      } else {
        lodingData = _.cloneDeep(this.productList);
      }
      {
        //移除
        console.log(lodingData, 'loading');
        //移除 全部页删除 不用这样删除
        if (this.modalValue.removeType == 2) {
          this.saveList.forEach(function (item, index, arr) {
            arr[index].activityProductStatus = 1;
          });
          this.productList = [];
          this.alreadySelect = [];
          this.selectProductList = [];
        } else {
          lodingData.forEach(function (item) {
            // this.productList = _.remove(this.productList, function(o) {
            // 	return o.optionId != item.optionId;
            // })
            _this4.selectProductList = _.remove(_this4.selectProductList, function (o) {
              return o.optionId != item.optionId;
            });
            _this4.saveList.forEach(function (item2, index, array) {
              if (item2.optionId == item.optionId) {
                array[index].activityProductStatus = 1;
              }
            });
            //移除过以后需要重新 获取一下当前页，要不然无法连续移除
            _this4.productList = _this4.saveList.filter(function (item) {
              return item.activityProductStatus == 0;
            });
            _this4.alreadySelect = _this4.productList.map(function (item) {
              return item.optionId;
            });
          });
        }
        this.crrentPageProductList = this.productList.slice((this.queryParam.page - 1) * this.queryParam.size, (this.queryParam.page - 1) * this.queryParam.size + this.queryParam.size);
      }
      //如果商品list为 0 那么需要把分页的页码重置
      if (this.productList.length == 0) {
        this.queryParam.page = 1;
      }
      this.listTotal = this.productList.length;
      this.selectedRowKeys = [];
      this.selectNumber = 0;
      this.removeTypeVisible = false;
    },
    resetFormDate: function resetFormDate() {
      this.removeTypeVisible = false;
    },
    //批量设置按钮
    removeClick: function removeClick(type) {
      this.buttonType = type;
      if (type == 0) {
        this.dialogStatus = 'batchoff';
        this.modalValue.discount = '';
      } else if (type == 1) {
        this.dialogStatus = 'batchnumber';
        this.modalValue.productNum = '';
      } else {
        this.dialogStatus = 'batchinvalid';
      }
      this.modalValue.removeType = 0;
      this.removeTypeVisible = true;
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.sortedInfo = sorter;
      if (sorter.columnKey) {
        if (typeof sorter.order == "undefined") {
          sorter.order = "ascend";
        }
        if (sorter.order == "ascend") {
          this.productList = _.orderBy(this.productList, ['productStatus'], ['asc']);
        } else {
          this.productList = _.orderBy(this.productList, ['productStatus'], ['desc']);
        }
      }
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      var newlist = _.cloneDeep(this.productList);
      //初始肯定是第一页，那么需要截取第一页的数据
      this.crrentPageProductList = newlist.slice((this.queryParam.page - 1) * this.queryParam.size, (this.queryParam.page - 1) * this.queryParam.size + this.queryParam.size);
    },
    addProduct: function addProduct() {
      var _this5 = this;
      this.$nextTick(function () {
        _this5.$refs.selectModal.visible = true;
      });
    },
    saveActivity: function saveActivity() {
      var _this6 = this;
      console.log("保存活动");
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this6.chooseproductparam.productType != 1) {
            // 指定商品不参加
            _this6.$refs.rangeRuleForm.validate(function (validtwo) {
              if (validtwo) {
                _this6.basicInformation.productType = _this6.chooseproductparam.productType,
                //第一版是 单品打折全部商品和指定不参加 不需要 设置参与件数
                // productNum: this.addProductIds,
                _this6.basicInformation.activityContent = _this6.chooseproductparam.activityContent, _this6.basicInformation.nameList = _this6.basicInformation.multilingualList, _this6.basicInformation.buyLimit = _this6.chooseproductparam.buyLimit, _this6.basicInformation.buyLimitNum = _this6.chooseproductparam.buyLimitNum, _this6.basicInformation.productList = _this6.productList;
                var updateTure = true;
                // 如果是指定商品不参加，并且商品列表为空时
                if (_this6.chooseproductparam.productType == 2) {
                  // if (this.basicInformation.productList == 0) {
                  // 	updateTure = false
                  // } else {
                  // 	updateTure = true
                  // }
                }
                if (updateTure) {
                  _this6.updateLoading = true;
                  addActivity(_this6.basicInformation).then(function (response) {
                    if (response.data.code == 200) {
                      _this6.$message.success(_this6.$t('public.addSuccessfully'));
                      _this6.$emit('nextStep');
                    } else {
                      _this6.$message.error(_this6.$t('public.addfail'));
                    }
                    _this6.updateLoading = false;
                  });
                } else {
                  _this6.$message.warning(_this6.$t('activity.isnull'));
                }
              } else {
                console.log('error submit!!');
                return false;
              }
            });
          } else {
            // 指定商品参加
            _this6.basicInformation.productType = _this6.chooseproductparam.productType, _this6.basicInformation.nameList = _this6.basicInformation.multilingualList,
            //第一版是 单品打折全部商品和指定不参加 不需要 设置参与件数
            // productNum: this.addProductIds,
            _this6.basicInformation.activityContent = _this6.chooseproductparam.activityContent, _this6.basicInformation.buyLimit = _this6.chooseproductparam.buyLimit, _this6.basicInformation.buyLimitNum = _this6.chooseproductparam.buyLimitNum, _this6.basicInformation.productList = _this6.productList;
            var updateTure = true;
            if (_this6.basicInformation.productList != 0) {
              _this6.basicInformation.productList.forEach(function (item) {
                if (item.activityContent === '' || item.activityContent == null) {
                  return updateTure = false;
                }
              });
            } else {
              updateTure = false;
            }
            if (updateTure) {
              _this6.updateLoading = true;
              addActivity(_this6.basicInformation).then(function (response) {
                if (response.data.code == 200) {
                  _this6.$message.success(_this6.$t('public.addSuccessfully'));
                  _this6.$emit('nextStep');
                } else {
                  _this6.$message.error(_this6.$t('public.addfail'));
                }
                _this6.updateLoading = false;
              });
            } else {
              _this6.$message.warning(_this6.$t('activity.isnull'));
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    nextStep: function nextStep() {
      console.log('这是哪里');
      if (this.chooseproductparam.productType == 1 && this.productList.length == 0) {
        this.$message.warning(this.$t('activity.warning'));
      } else {
        console.log('这是哪里222');
        var newList = this.saveList.filter(function (item) {
          return item.activityProductStatus == 0;
        });
        var saveList2 = newList.map(function (item) {
          return {
            activityId: null,
            optionId: item.optionId,
            activityProductStatus: item.activityProductStatus,
            productNum: 0,
            activityContent: 0
          };
        });
        var ProductParamInfo = {
          productType: this.chooseproductparam.productType,
          productList: saveList2,
          buyLimit: 0,
          activityContent: 0
        };
        console.log(ProductParamInfo, '12233');
        this.$emit('nextStep', ProductParamInfo);
      }
    },
    // getVisible(visible) {
    // 	this.visible = visible;
    // },
    getProductkeylist: function getProductkeylist(addProductKeyList) {},
    /* 添加按钮 */addNewProduct: function addNewProduct() {
      this.visible = true;
    },
    /* 操作上的移除 */confirm: function confirm(record) {
      this.saveList.forEach(function (item, index, array) {
        if (item.optionId == record.optionId) {
          array[index].activityProductStatus = 1;
        }
      });
      //将这条记录从商品list 中移除
      // this.productList = _.remove(this.productList, function(o) {
      // 	return o.optionId != record.optionId;
      // });
      //移除过以后需要重新 获取一下当前页，要不然无法批量设置值
      this.productList = this.saveList.filter(function (item) {
        return item.activityProductStatus == 0;
      });
      this.alreadySelect = this.productList.map(function (item) {
        return item.optionId;
      });
      this.crrentPageProductList = this.productList.slice((this.queryParam.page - 1) * this.queryParam.size, (this.queryParam.page - 1) * this.queryParam.size + this.queryParam.size);
      this.listTotal = this.productList.length;
      // this.$message.success(this.$t('public.deleteSuccessfully'));
    },
    /* 切换商品范围 */rangetypeChange: function rangetypeChange() {
      //如果切换了商品范围，那么原来失效的商品ids 清空
      this.deleteProductIds = [];
      this.productList = _.cloneDeep(this.productList);
      //总条数清空
      this.listTotal = this.productList.length;
      //折扣清空
      this.chooseproductparam.activityContent = '';
      // this.$refs.rangeRuleForm.validateField(["activityContent"])
    },
    cancel: function cancel(e) {
      // this.$message.error(this.$t('public.cancelSuccessfully'));
    },
    confirmProduct: function confirmProduct(data) {
      // 这里有分页 有影响吗
      console.log(data);
      this.productList = data;
      this.saveList = _.cloneDeep(this.productList);
      this.saveList.forEach(function (item, index, arr) {
        arr[index].activityProductStatus = 0;
      });
      // this.saveList = this.saveList.map(item => {
      // 	return  {
      // 		activityId:null,
      // 		optionId: item.optionId,
      // 		activityProductStatus: 0,
      // 		productNum:0,
      // 		activityContent:0
      // 	}
      // })
      this.crrentPageProductList = this.productList.slice(0, this.queryParam.size);
      this.alreadySelect = this.productList.map(function (item) {
        return item.optionId;
      });
      this.listTotal = this.productList.length;
    },
    getData: function getData() {
      var _this7 = this;
      this.isTableLoading = true;
      getActivityProduct(this.$route.query.id).then(function (response) {
        var productData = response.data.data;
        if (productData !== null) {
          _this7.chooseproductparam.productType = productData.productType;
          _this7.productList = productData.productList;
          _this7.saveList = _.cloneDeep(_this7.productList);
          _this7.originalList = _.cloneDeep(_this7.productList);
          _this7.originalMap = new Map();
          _this7.originalList.forEach(function (item, index, arr) {
            item.myindex = index;
            console.log(item);
            _this7.originalMap.set(item.optionId, item);
          });
          _this7.alreadySelect = _this7.productList.map(function (item) {
            return item.optionId;
          });
          // 	//初始肯定是第一页，那么需要截取第一页的数据
          _this7.crrentPageProductList = _this7.productList.slice(0, _this7.queryParam.size);
          _this7.listTotal = _this7.productList.length;
        }
      }).finally(function () {
        _this7.isTableLoading = false;
      });
    }
  }
};